import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "label-manage"
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("标签名称")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("标签名称")
    },
    model: {
      value: _vm.form.tagsName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "tagsName", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.tagsName"
    }
  })], 1), _c("a-form-item", [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.onSearch
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _vm.isAuth("home.tagsStore") ? _c("a-button", {
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.openAddModal(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增标签")))]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.tableData,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.tablePageChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (_, record, index) {
        return [_vm._v(_vm._s((_vm.pagination.current - 1) * _vm.pagination.pageSize + Number(index + 1)))];
      }
    }, {
      key: "operation",
      fn: function (text, record) {
        return [_vm.isAuth("home.tagsAttributeList") ? _c("a-button", {
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "labelProperty",
                params: {
                  tagsName: record.label
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("属性管理")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("add-modal", {
    attrs: {
      visible: _vm.addVisible,
      isEdit: _vm.isEdit
    },
    on: {
      save: _vm.onSearch,
      cancel: function ($event) {
        _vm.addVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };